<div>
    <div class="modal-header">
        {{ headerText }}
    </div>
    <div class="modal-body">
        <img [src]="imagePath" style="max-width:100%;" />
    </div>
    <div class="modal-footer">
        <button type="button" 
                class="btn btn-text-primary" 
                (click)="closeModal()">Close</button>
    </div>
</div>